import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
// import { useState } from 'react';
// import Popup4868 from '@/components/ui/4868Popup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Click2File = () => {
  // const [open, setOpen] = useState(false);
  const [referralUrl, SetReferralUrl] = useState('click2file');
  const forms = [
    { id: 0, title: 'Click2File', icon: '' },
    { id: 1, title: 'Form 990', icon: '' },
    { id: 2, title: 'Form 990-EZ', icon: '' },
    { id: 3, title: 'Form 990-PF', icon: '' },
    { id: 4, title: 'Form 199', icon: '' },
    { id: 5, title: 'Form 8868', icon: '' },
  ];
  const [active, setActive] = useState(0);
  useEffect(() => {
    const isIRSPageReferral = document.referrer === 'https://www.irs.gov/';
    if (isIRSPageReferral) SetReferralUrl('click2fileirs');
  }, []);
  return (
    <AppLayout
      meta={
        <Meta
          title="E-File Extension Forms Quickly using Click2File"
          description="Use Click2File to e-file IRS Forms 7004, 4868, and 8868 for your tax extensions. Our feature provides a streamlined and accurate filing process. E-file Now"
          keywords="form 4868, irs form 4868, 4868 form, e file form 4868 tax extension, form 4868 online, form 4868 instructions, instructions for form 4868, form 4868 extension, tax form 4868, IRS authorized provider"
          canonical="features/click2file/"
        />
      }
    >
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 }, py: { xs: 2, sm: 3, md: 5, lg: 6 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', sm: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                justifyContent={{ xs: 'center', md: 'flex-start' }}
                alignItems="center"
                sx={{ mt: 0, mb: 2 }}
              >
                <Box
                  component="img"
                  src="/assets/images/click2file-icon.svg"
                  alt="Click2File"
                  sx={{ maxWidth: 100 }}
                />
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                    fontWeight: 600,
                    color: '#374151',
                    mb: 3,
                  }}
                >
                  Simplify Your 2025 Tax Season with{' '}
                  <span className="highlight-container">
                    <span className="highlight">Click2File</span>
                  </span>{' '}
                </Typography>
              </Stack>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  display: 'flex',
                  alignItems: 'center',
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                <DoubleArrowIcon sx={{ mr: 1 }} /> It take less than few minutes
                to complete your Tax Filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  display: 'flex',
                  alignItems: 'center',
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                <DoubleArrowIcon sx={{ mr: 1 }} /> Tax season just got a whole
                lot simpler with Click2File!
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    Click2File Now
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              px: { xs: 0, sm: 3 },
              py: { xs: 1, sm: 3 },
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
                minHeight: { xs: '100%', sm: 350, md: 'auto', lg: 400 },
                borderRadius: 3,
                mb: { sm: 3, md: 0 },
                border: '5px solid #333',
              }}
              component="iframe"
              src="https://www.youtube.com/embed/rEsXdf5Vy7M?si=tclr96oGdp8D7j5R&rel=0"
              title="TaxZerone's Click2File: Create Current Year Return from Prior Year Data"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen={true}
            />
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Say goodbye to the hassle of manually entering
                <br />
                your tax information
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Automatically transfers relevant data from your previous year to
                your current one, saving you time and reducing errors.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <img
                    src="/assets/images/7004-icon.svg"
                    alt="Form 7004"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form 7004
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 7004
                  </Link>{' '}
                  is an official IRS form used to request an extension for
                  filing various business tax forms.
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    size="large"
                    variant="contained"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 3,
                      textTransform: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    File Form 7004 Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <img
                    src="/assets/images/4868-icon.svg"
                    alt="Form 4868"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form 4868
                </Typography>
                <Typography variant="body1">
                  IRS{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 4868
                  </Link>{' '}
                  is filed by individual taxpayers to get an extension to file
                  income tax
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    size="large"
                    variant="contained"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 3,
                      textTransform: 'none',
                      backgroundColor: '#1da94a',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        backgroundColor: '#1a7738',
                        transform: 'scale(1.1)',
                      },
                    }}
                  >
                    File Form 4868 Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <img
                    src="/assets/images/8868-icon.svg"
                    alt="Form 8868"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form 8868
                </Typography>
                <Typography variant="body1">
                  IRS{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 8868
                  </Link>{' '}
                  is an extension form filed by nonprofits and tax-exempt
                  organizations
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    size="large"
                    variant="contained"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 3,
                      textTransform: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    File Form 8868 Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 }, mb: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center" justifyContent="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Simplify Exempt Organization Return Filing with Click2File
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                <span style={{ fontWeight: 600 }}> Click2File</span> helps
                returning{' '}
                <Link href="/" sx={{ color: '#0202ff' }}>
                  {' '}
                  TaxZerone
                </Link>{' '}
                users file faster by automatically pulling information from
                previously filed returns and carrying it forward to the current
                tax year. This simplifies the filing process, reduces repetitive
                data entry, and helps improve accuracy.
              </Typography>
            </Grid>

            <Grid
              size={{ md: 6, sm: 12, xs: 12 }}
              sx={{
                '& .wrapper': {
                  display: 'flex',
                  gap: '80px',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
                '& .wheel': {
                  position: 'relative',
                  width: { xs: '350px', sm: '550px' },
                  height: { xs: '350px', sm: '550px' },
                  borderRadius: '50%',
                  backgroundColor: '#0b4da2',
                  border: '8px solid #0b4da2',
                  overflow: 'hidden',
                },
                '& .center': {
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: { xs: 150, sm: 210 },
                  height: { xs: 150, sm: 210 },
                  borderRadius: '50%',
                  background: '#003b8f',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: '.3s',
                  boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                },

                '& .center:hover': {
                  transform: 'translate(-50%, -50%) scale(1.05)',
                },

                '& .segment': {
                  position: 'absolute',
                  width: '95%',
                  height: '95%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 20,
                  border: 'none',
                  cursor: 'pointer',
                  color: '#222222',
                  transition: ' .35s',
                  clipPath: 'polygon(50% 100%, 0% 0%, 100% 0%)',
                  fontSize: 18,
                  fontWeight: 600,
                  fontFamily: 'poppins',
                },

                '& .segment1': {
                  left: { xs: '9%', sm: '1%' },
                  top: { xs: '-122px', sm: '-207px' },
                  transform: { xs: 'rotate(8deg)', sm: 'rotate(0deg)' },
                },
                '& .segment2': {
                  right: { xs: '-37.2%', sm: '-34.2%' },
                  top: { xs: '-9px', sm: '-59px' },
                  transform: { xs: 'rotate(80deg)', sm: 'rotate(69deg)' },
                },
                '& .segment3': {
                  right: { xs: '-13%', sm: '-22%' },
                  bottom: { xs: '-109px', sm: '-157px' },
                  transform: { xs: 'rotate(157deg)', sm: 'rotate(139deg)' },
                },
                '& .segment4': {
                  right: { xs: '33%', sm: '27%' },
                  bottom: { xs: '-80px', sm: '-176px' },
                  transform: { xs: 'rotate(226deg)', sm: 'rotate(213deg)' },
                },
                '& .segment5': {
                  right: { xs: '40%', sm: '42%' },
                  bottom: { xs: '71px', sm: '73px' },
                  transform: { xs: 'rotate(293deg)', sm: 'rotate(287deg)' },
                },

                '& .segment.active': {
                  background: '#1da94a',
                  // boxShadow: '0 0 30px #29b6ff',
                  color: '#fff',
                  boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                },
              }}
            >
              <Box className="wrapper">
                <Box className="wheel">
                  <Box
                    className={`center ${active === 0 ? 'active' : ''}`}
                    onClick={() => setActive(0)}
                  >
                    <Box
                      component="img"
                      src="/assets/images/click2file-icon.webp"
                      alt="Click2File"
                      sx={{
                        width: { xs: 140, sm: 200 },
                        height: { xs: 140, sm: 200 },
                      }}
                    />
                  </Box>
                  {forms.slice(1).map((item, index) => (
                    <button
                      key={item.id}
                      className={`segment segment${index + 1} ${
                        active === item.id ? 'active' : ''
                      }`}
                      onClick={() => setActive(item.id)}
                    >
                      {item.title}
                    </button>
                  ))}
                </Box>
              </Box>
            </Grid>

            <Grid size={{ md: 6, sm: 6, xs: 12 }}>
              <Box className="content">
                {active === 0 && (
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 3,
                        textAlign: 'left',
                        lineHeight: 1.5,
                      }}
                    >
                      Supported Exempt Organization Forms with Click2File{' '}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Click2File is a time-saving feature designed for returning
                      TaxZerone users. If you previously filed an exempt
                      organization return with TaxZerone, Click2File can
                      automatically carry forward relevant information from your
                      prior-year filing into the current tax year. This helps
                      reduce repetitive data entry and simplifies the return
                      preparation process.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      TaxZerone currently supports Click2File for the following
                      exempt organization forms:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>Form 990</li>
                      <li>Form 990-EZ </li>
                      <li>Form 990-PF</li>
                      <li>Form 8868 </li>
                      <li>California Form 199 </li>
                    </Box>
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 2,
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                          },
                        }}
                        className="btn-primary"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Box>
                )}
                {active === 1 && (
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 3,
                        textAlign: 'left',
                        lineHeight: 1.5,
                      }}
                    >
                      Form 990 - Return of Organization Exempt from Income Tax
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Generally, exempt organizations with{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        gross receipts of $200,000 or more or total assets of
                        $500,000 or more
                      </span>{' '}
                      are required to file{' '}
                      <Link
                        href="/tax-exempt/e-file-irs-form-990/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 990
                      </Link>
                      . Used to report annual financial and organizational
                      information to the IRS.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      How Click2File Helps
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        Imports data from your prior-year TaxZerone filing.{' '}
                      </li>
                      <li>Reduces repetitive data entry. </li>
                      <li>Saves time during return preparation. </li>
                      <li>Simplifies annual filing. </li>
                    </Box>
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 2,
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                          },
                        }}
                        className="btn-primary"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                      >
                        File Form 990
                      </Button>
                    </Box>
                  </Box>
                )}
                {active === 2 && (
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 3,
                        textAlign: 'left',
                        lineHeight: 1.5,
                      }}
                    >
                      Form 990-EZ - Short Form Return of Organization Exempt
                      from Income Tax
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Generally, exempt organizations with{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        gross receipts of less than $200,000 and total assets of
                        less than $500,000
                      </span>{' '}
                      may be eligible to file{' '}
                      <Link
                        href="/tax-exempt/e-file-irs-form-990-ez/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 990-EZ
                      </Link>
                      instead of the longer Form 990.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      How Click2File Helps
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>Carries forward prior-year filing information.</li>
                      <li>Saves time on return preparation. </li>
                      <li>Streamlines the filing process. </li>
                    </Box>
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 2,
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                          },
                        }}
                        className="btn-primary"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                      >
                        File Form 990-EZ
                      </Button>
                    </Box>
                  </Box>
                )}
                {active === 3 && (
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 3,
                        textAlign: 'left',
                        lineHeight: 1.5,
                      }}
                    >
                      Form 990-PF – Return of Private Foundation
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      <Link href="" sx={{ color: '#0202ff' }}>
                        {' '}
                        Form 990-PF
                      </Link>{' '}
                      is filed annually by{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        private foundations,
                      </span>{' '}
                      regardless of their revenue or asset size. The form is
                      used to report financial activities, investments, grants,
                      contributions, and charitable distributions.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      How Click2File Helps:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        Reuses information from your last TaxZerone return.
                      </li>
                      <li>Minimizes repetitive data entry. </li>
                      <li>Makes the 990-PF annual filing easier </li>
                    </Box>
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 2,
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                          },
                        }}
                        className="btn-primary"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                      >
                        File Form 990-PF
                      </Button>
                    </Box>
                  </Box>
                )}
                {active === 4 && (
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 3,
                        textAlign: 'left',
                        lineHeight: 1.5,
                      }}
                    >
                      California Form 199 - Exempt Organization Annual
                      Information Return
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      California tax-exempt organizations must generally file{' '}
                      <Link
                        href="/tax-exempt/efile-ftb-ca-form199-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 199
                      </Link>{' '}
                      annually with the California Franchise Tax Board (FTB) to
                      report their financial activities and maintain state
                      tax-exempt status.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      How Click2File Helps:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        Uses information from your federal return filed with
                        TaxZerone.
                      </li>
                      <li>Reduces duplicate data entry. </li>
                      <li>Simplifies CA Form 199 preparations. </li>
                    </Box>
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 2,
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                          },
                        }}
                        className="btn-primary"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                      >
                        File CA Form 199
                      </Button>
                    </Box>
                  </Box>
                )}
                {active === 5 && (
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 3,
                        textAlign: 'left',
                        lineHeight: 1.5,
                      }}
                    >
                      Form 8868 - Application for Extension of Time to File
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      <Link
                        href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 8868
                      </Link>{' '}
                      allows exempt organizations to request an automatic
                      extension of time to file certain exempt organization
                      returns, helping them avoid late-filing penalties when
                      additional time is needed.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      How Click2File Helps:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>Pulls data from your previous TaxZerone filing.</li>
                      <li>Minimizes repetitive entry. </li>
                      <li>Streamlines Form 8868 preparation. </li>
                    </Box>
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 2,
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                          },
                        }}
                        className="btn-primary"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                      >
                        File Extension 8868
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How Click2File Works
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Click2File takes the hassle out of tax preparation by
                automatically transferring relevant data
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                from your previous return to your current one.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/click2file-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/click2file-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/click2file-img.png"
                  alt="How Click2File Works"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Login and Select"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Login and Select
                    </Typography>
                    <Typography variant="body1">
                      Access your TaxZerone account and choose Click2File Form
                      7004, Form 4868, Form 8868, or Form 990 series (990,
                      990-EZ, 990-PF)
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Review and Customize"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review and Customize
                    </Typography>
                    <Typography variant="body1">
                      Click2File instantly populates your current return with
                      essential details. Review and adjust anything to
                      accurately reflect your current financial situation.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="File with Ease"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      File with Ease
                    </Typography>
                    <Typography variant="body1">
                      Once everything looks perfect, submit your return
                      electronically. Click2File streamlines the filing process,
                      making it a breeze!
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                >
                  Click2File Now
                </Button>
                {/* <Typography
                  variant="body2"
                  sx={{ mt: 1, mb: { xs: 2, sm: 2, md: 5 } }}
                >
                  You are just 3 steps away from getting an extension.
                </Typography> */}
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',

          mx: '0 !important',
          width: '100% !important',
          py: { xs: 1, sm: 3 },
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            pb={5}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Why Choose Click2File?
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/efficiency-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/efficiency-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/efficiency-icon.png"
                      alt="Efficiency"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Efficiency
                </Typography>
                <Typography variant="body1">
                  Save time by eliminating manual data entry.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/accuracy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/accuracy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/accuracy-icon.png"
                      alt="Accuracy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Accuracy
                </Typography>
                <Typography variant="body1">
                  Reduce errors with automatic population of relevant details.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/convenience-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/convenience-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/convenience-icon.png"
                      alt="Convenience"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Convenience
                </Typography>
                <Typography variant="body1">
                  File your taxes from the comfort of your own home.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/mind-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/mind-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/mind-icon.png"
                      alt="Peace of Mind"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Peace of Mind
                </Typography>
                <Typography variant="body1">
                  Rest assured knowing your return is accurately completed.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Stop stressing over tax preparation and start simplifying
          <Hidden smDown>
            <br />
          </Hidden>{' '}
          your filing process with Click2File
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Join thousands of satisfied users who trust TaxZerone for their tax
          needs.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
          >
            Get Started Now
          </Button>
          <Typography
            variant="body2"
            sx={{ mt: 1, mb: { xs: 0, md: 0 } }}
            color="#dfeae1"
          >
            Simple. Secure. Accurate.
          </Typography>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is Click2File and how does it work?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    Click2File is a convenient tax filing feature offered by
                    TaxZerone that simplifies the process by pre-populating your
                    current tax year return with data from your previous tax
                    year&apos;s return. This streamlines filing for common forms
                    like{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      7004
                    </Link>
                    ,{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      4868
                    </Link>
                    ,{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      8868
                    </Link>
                    ,{' '}
                    <Link
                      href="/tax-exempt/e-file-irs-form-990/"
                      sx={{ color: '#0202ff' }}
                    >
                      990
                    </Link>
                    ,{' '}
                    <Link
                      href="/tax-exempt/e-file-irs-form-990-ez/"
                      sx={{ color: '#0202ff' }}
                    >
                      990-EZ
                    </Link>
                    ,
                    <Link
                      href="/tax-exempt/e-file-irs-form-990-pf/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      990-PF
                    </Link>
                    , and{' '}
                    <Link
                      href="/tax-exempt/efile-ftb-ca-form199-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      CA 199
                    </Link>{' '}
                    by automatically carrying over relevant information, saving
                    you time and effort.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Does Click2File provide any guidance or support for filing
                  my business tax return?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography>
                      TaxZerone typically offers resources like FAQs, Field
                      level help,{' '}
                      <Link
                        href="https://blog.taxzerone.com/posts/e-file-form-7004-in-seconds-with-taxzerones-click2file/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Blogs
                      </Link>{' '}
                      and{' '}
                      <Link
                        href="https://support.taxzerone.com/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Support Site
                      </Link>{' '}
                      to answer common questions and guide you through the
                      Click2File process. You may also have email, chat or phone
                      support options for more specific assistance.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Can I edit or modify the pre-populated information in
                  Click2File?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    Absolutely! Click2File provides flexibility to review and
                    modify any pre-populated data to reflect your current
                    year&apos;s financial standing. You can enter new
                    information, adjust existing values, or delete irrelevant
                    entries as needed.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What are the benefits of using Click2File compared to
                  manually filing my business tax return?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography>
                      Click2File offers several advantages:
                    </Typography>
                    <List sx={{ pb: 0 }}>
                      <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                        <ListItemIcon
                          sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                        >
                          <DoubleArrowIcon />
                        </ListItemIcon>
                        <ListItemText>
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Saves time and effort:
                          </span>{' '}
                          Pre-populated data reduces manual entry, streamlining
                          the filing process.
                        </ListItemText>
                      </ListItem>
                      <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                        <ListItemIcon
                          sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                        >
                          <DoubleArrowIcon />
                        </ListItemIcon>
                        <ListItemText>
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Improves accuracy:
                          </span>{' '}
                          Carryover of consistent data from the previous year
                          minimizes errors.
                        </ListItemText>
                      </ListItem>
                      <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                        <ListItemIcon
                          sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                        >
                          <DoubleArrowIcon />
                        </ListItemIcon>
                        <ListItemText>
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Simplifies tax season:
                          </span>{' '}
                          Makes filing smoother and less stressful, especially
                          for returns with minimal changes.
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Click2File;
